<template>
  <v-container fill-height>
    <v-layout column justify-center>
      <v-flex shrink>
        <v-layout justify-center>
          <v-flex xs12 sm8 md6 lg4>
            <v-login-card class="elevation-10" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import VLoginCard from "./components/LoginCard";

export default {
  components: {
    VLoginCard
  }
};
</script>